module.exports = __webpack_public_path__ + "img/client-12.fa2ef573.png";